import { network } from '@utils'
import { QueryFunction } from './root'

interface HeaderPathProps {
  slug: string
  number: number
}

interface HeaderPathResponse {
  headers: string[]
}

export const fetchHeaderPath: QueryFunction<HeaderPathProps, HeaderPathResponse> = async ({
  slug,
  number
}) => {
  const url = `/v1/business/${slug}/coa/path/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET',
    params: { number }
  })
  return data
}
